"use client";

import { useState, useSyncExternalStore } from "react";
import { install, installState, watchInstall } from "@/lib/install";
import styles from "./install-button.module.css";

/* Put it on the phone. What it can honestly offer is worked out in lib/install, which
   starts listening as the app loads rather than when this mounts, because the browser only
   ever announces itself once and it does it early.

   Anywhere already installed, or with no route to install, this is nothing rather than a
   dead button. */

export function InstallButton() {
  const [showHow, setShowHow] = useState(false);
  const mode = useSyncExternalStore(watchInstall, installState, () => "none" as const);

  if (mode === "none") return null;
  if (mode === "done") return <p className={styles.done}>On your home screen. See you there.</p>;

  if (mode === "ios") {
    return (
      <div className={styles.wrap}>
        <button type="button" className={styles.button} onClick={() => setShowHow((v) => !v)} aria-expanded={showHow}>
          Install on your phone
        </button>
        {showHow && (
          <p className={styles.how}>
            Tap the share button at the bottom of Safari, then <strong>Add to Home Screen</strong>.
            Apple gives no button for this, so it has to be you.
          </p>
        )}
      </div>
    );
  }

  return (
    <div className={styles.wrap}>
      <button type="button" className={styles.button} onClick={() => void install()}>
        Install on your phone
      </button>
    </div>
  );
}
